'use es6';

export default {};